import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=52c120c7"
import script from "./ArticleItem.vue?vue&type=script&lang=ts"
export * from "./ArticleItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports